export default __webpack_public_path__ + "static/media/IMG-20241005-WA0047.0f28d0ac.jpg";